module.exports = __webpack_public_path__ + "static/media/elevated1.ed1150c4.webp";